export default __webpack_public_path__ + "static/media/Location.7680aad1.svg";